<script setup lang="ts">
type Props = {
    url: string
    platform: string
    icon: string
}

const { url, platform, icon } = defineProps<Props>()
</script>

<template>
    <a
        :href="url"
        target="_blank"
        rel="noreferrer"
        class="py-0.5 px-4 rounded-md flex items-center gap-3 transition-colors hover:bg-gray-100 duration-300"
    >
        <i class="lni text-xl" :class="icon" aria-hidden="true"></i>

        <div class="text-sm">
            <span>{{ platform }}</span>
        </div>
    </a>
</template>
